// extracted by mini-css-extract-plugin
export default {"p_tye":"_5f95174826","slcted":"_97caf3ee85","slc_color":"d5a87db6e2","item_p":"_2b02d66051","r0":"_9d16e60b1d"};